import { CUSTOM_ELEMENTS_SCHEMA, Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-web-component-test-view',
  standalone: true,
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './web-component-test-view.component.html',
  styleUrls: ['./web-component-test-view.component.scss']
})
export class WebComponentTestViewComponent {
  token =
    'eyJraWQiOiIyR1Y5M20yQWk4cVhvNE9BME5pd0hQdkdnWFk5WGVDZEdDa2FmaTR0QWdFPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI3Y2NkMTUxNC02Njk4LTRkMjktYmY4My01ZDAyOTNjY2I2NjciLCJjb2duaXRvOmdyb3VwcyI6WyJNdWx0aWFzaXN0ZW5jaWEiXSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLmV1LXdlc3QtMS5hbWF6b25hd3MuY29tXC9ldS13ZXN0LTFfbmpTdlFHTXhWIiwiY2xpZW50X2lkIjoiNnZucmptMnRzMGk0bDM0ZzdscmY2bGNsOGIiLCJldmVudF9pZCI6IjRkZGQxYmI5LWE3MjctNDFhOC04ZGMxLTZiNDUxMjYyZDc4MiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE3MTEwMjgwOTUsImV4cCI6MTcxMTA2NDA5NSwiaWF0IjoxNzExMDI4MDk1LCJqdGkiOiI3ZDFhZDFmOC02YWQ5LTRhNmItOThiZS03MWFjNWQ3MzA5YjMiLCJ1c2VybmFtZSI6Im1hdmFsdWV1c2VyZGUifQ.XrQwc4t34lfDovgMht6bV5eRxDPZZVu-qTnJDEx8k8bM9RUsdO-CMQaZWAmp2pNO71MG5EdR-4izh43eyrtNd1Hgybr3GvjHebBqHON5pGEUthFkQ9z_LqjJDYipyW4zLlEAJosy5tAWxQ6GDlgOWcIUF__BoTT6vhDjlT4YhNgcBKmxubwkHCGuJrbAdZjiaLVfOUpTIH2UmaHtDr9uhdDpvvu2CUvQgJmvzan89q4MykWCV6JKkJgjf6V0wivRcXyk9Rzrcr5jbZ2aQd9XixChgTuMYeW_w8rgqMPDVj0YHtjVusmzcwoFEXtSiP4Fdy98eKPiYYp4g6Qm8xqy6Q';
  sinisterId = 'testwebc01';
  formId = '148';

  onCancel(event: Event) {
    alert('Proccess canceled');
  }

  tokenHasExpired(event: Event) {
    alert('Token expired');
  }

  onProcessCompleted(event: Event) {
    alert('Proccess completed');
  }
}
